import React, { useState } from "react";
import { sendContactFormEmail } from "../api/email";
import { toast } from "react-toastify";
import { CiPhone } from "react-icons/ci";
import { MdOutlineEmail } from "react-icons/md";
import { FaRegMessage } from "react-icons/fa6";
import { Link } from "react-router";

export default function ContactUs() {
  const [formValidation, setFormValidation] = useState({
    name: null,
    email: null,
    subject: null,
  });
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [termsChecked, setTermsChecked] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (formValidation[name] !== null) {
      validateField(name, value);
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const validateField = (field, value) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (field === "name" || field === "subject") {
      if (value === "") {
        setFormValidation((prevValidation) => ({
          ...prevValidation,
          [field]: false,
        }));
        return false;
      } else {
        setFormValidation((prevValidation) => ({
          ...prevValidation,
          [field]: true,
        }));
        return true;
      }
    } else if (field === "email") {
      if (emailRegex.test(value)) {
        setFormValidation((prevValidation) => ({
          ...prevValidation,
          [field]: true,
        }));
        return true;
      } else {
        setFormValidation((prevValidation) => ({
          ...prevValidation,
          [field]: false,
        }));
        return false;
      }
    }
    return true;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const isNameValid = validateField("name", formData.name);
      const isEmailValid = validateField("email", formData.email);
      const isSubjectValid = validateField("subject", formData.subject);
      if (isNameValid && isEmailValid && isSubjectValid) {
        await sendContactFormEmail(formData);
        toast.success("Thank you! Your message has been sent.");
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
        setFormValidation({
          name: null,
          email: null,
          subject: null,
        });
      }
    } catch {
      toast.error("Server Error. Please try again.");
    }
  };
  return (
    <div className="flex flex-1 items-center justify-center">
      <section className="flex flex-col items-center justify-center p-6 lg:w-2/3 xl:w-1/2">
        <h2 className="mb-1.5 text-lg font-bold text-primaryColor md:mb-2 md:text-2xl lg:mb-3 lg:text-4xl">
          Get in Touch
        </h2>
        <h3 className="mb-1.5 text-center text-sm md:mb-2 md:text-lg lg:mb-3 lg:text-xl">
          We would love to hear from you.
        </h3>
        <h3 className="mb-2.5 text-center text-sm md:mb-4 md:text-lg lg:mb-5 lg:text-xl">
          Whether you're looking for more information about our services,
          require tailored offshore crewing solutions, or want to explore a
          partnership, our team is here to assist.
        </h3>
        <div className="mb-2.5 flex w-full flex-wrap justify-between gap-4 md:mb-4 md:gap-6 lg:mb-5 lg:gap-8 xl:mb-6">
          <div className="flex w-full flex-col items-center gap-2 rounded-3xl bg-primaryHover p-2 md:w-5/12 md:p-3 lg:gap-4 lg:p-4 xl:p-5">
            <CiPhone className="text-lg text-secondaryColor md:text-xl lg:text-2xl xl:text-4xl" />
            <h4 className="text-sm uppercase text-secondaryColor md:text-base lg:text-lg xl:text-xl">
              Phone
            </h4>
            <p className="text-sm text-secondaryColor md:text-base lg:text-lg xl:text-xl">
              +44 (0)1642 205288
            </p>
          </div>
          <div className="flex w-full flex-col items-center gap-2 rounded-3xl bg-primaryHover p-2 md:w-5/12 md:p-3 lg:gap-4 lg:p-4 xl:p-5">
            <MdOutlineEmail className="text-lg text-secondaryColor md:text-xl lg:text-2xl xl:text-4xl" />
            <h4 className="text-sm uppercase text-secondaryColor md:text-base lg:text-lg xl:text-xl">
              Email
            </h4>
            <a
              href="mailto:info@accesscv.co.uk"
              className="text-sm text-secondaryColor underline hover:text-secondaryHover md:text-base lg:text-lg xl:text-xl"
            >
              info@accesscv.co.uk
            </a>
          </div>
        </div>
        <FaRegMessage className="mb-1 self-start text-lg text-secondaryColor md:mb-2 md:text-xl lg:mb-3 lg:text-2xl xl:text-4xl" />

        <h3 className="mb-2.5 self-start text-base md:mb-4 md:text-lg lg:mb-5 lg:text-xl xl:mb-6 xl:text-2xl">
          Alternatively, send us a message and we'll get back to you.
        </h3>
        <form
          className="flex w-full flex-col items-center gap-3 md:gap-3.5"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="relative w-full">
            <input
              type="text"
              id="name"
              className={`peer appearance-none border-2 shadow ${formValidation.name ? "border-green-500" : formValidation.name === false ? "border-red-500" : "focus:ring"} h-10 w-full rounded-3xl px-3 py-2 text-sm leading-tight text-gray-700 placeholder:text-transparent focus:outline-none md:h-14 md:text-base lg:h-16 lg:text-lg`}
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              onBlur={() => validateField("name", formData.name)}
              required
              placeholder="Name"
            />
            <label
              htmlFor="name"
              className="absolute left-0 top-2 ml-2 -translate-y-5 bg-white px-1 text-base text-gray-500 duration-100 ease-linear peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5 peer-focus:px-1 md:top-3 md:-translate-y-7 md:text-lg md:peer-focus:-translate-y-7 lg:top-4 lg:ml-3 lg:-translate-y-8 lg:text-xl lg:peer-focus:-translate-y-8"
            >
              Name
            </label>
            <p
              className={`text-xs italic text-red-600 md:text-sm lg:mt-0.5 lg:text-base ${formValidation.name !== false && "invisible"}`}
            >
              Please provide a name.
            </p>
          </div>
          <div className="relative w-full">
            <input
              type="email"
              id="email"
              className={`peer appearance-none border-2 shadow ${formValidation.email ? "border-green-500" : formValidation.email === false ? "border-red-500" : "focus:ring"} h-10 w-full rounded-3xl px-3 py-2 text-sm leading-tight text-gray-700 placeholder:text-transparent focus:outline-none md:h-14 md:text-base lg:h-16 lg:text-lg`}
              name="email"
              value={formData.email || ""}
              onChange={handleChange}
              onBlur={() => validateField("email", formData.email)}
              required
              placeholder="Email"
            />
            <label
              htmlFor="email"
              className="absolute left-0 top-2 ml-2 -translate-y-5 bg-white px-1 text-base text-gray-500 duration-100 ease-linear peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5 peer-focus:px-1 md:top-3 md:-translate-y-7 md:text-lg md:peer-focus:-translate-y-7 lg:top-4 lg:ml-3 lg:-translate-y-8 lg:text-xl lg:peer-focus:-translate-y-8"
            >
              Email
            </label>
            <p
              className={`text-xs italic text-red-600 md:text-sm lg:mt-0.5 lg:text-base ${formValidation.email !== false && "invisible"}`}
            >
              Please provide a valid email.
            </p>
          </div>
          <div className="relative w-full">
            <input
              type="text"
              id="subject"
              className={`peer appearance-none border-2 shadow ${formValidation.subject ? "border-green-500" : formValidation.subject === false ? "border-red-500" : "focus:ring"} h-10 w-full rounded-3xl px-3 py-2 text-sm leading-tight text-gray-700 placeholder:text-transparent focus:outline-none md:h-14 md:text-base lg:h-16 lg:text-lg`}
              name="subject"
              value={formData.subject || ""}
              onChange={handleChange}
              onBlur={() => validateField("subject", formData.subject)}
              required
              placeholder="subject"
            />
            <label
              htmlFor="subject"
              className="absolute left-0 top-2 ml-2 -translate-y-5 bg-white px-1 text-base text-gray-500 duration-100 ease-linear peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5 peer-focus:px-1 md:top-3 md:-translate-y-7 md:text-lg md:peer-focus:-translate-y-7 lg:top-4 lg:ml-3 lg:-translate-y-8 lg:text-xl lg:peer-focus:-translate-y-8"
            >
              Subject
            </label>
            <p
              className={`text-xs italic text-red-600 md:text-sm lg:mt-0.5 lg:text-base ${formValidation.subject !== false && "invisible"}`}
            >
              Please provide a subject.
            </p>
          </div>
          <div className="relative w-full">
            <textarea
              rows={5}
              id="message"
              className={`peer appearance-none border-2 shadow ${formValidation.message ? "border-green-500" : formValidation.message === false ? "border-red-500" : "focus:ring"} w-full rounded-3xl px-3 py-2 text-sm leading-tight text-gray-700 placeholder:text-transparent focus:outline-none md:text-base lg:text-lg`}
              name="message"
              value={formData.message || ""}
              onChange={handleChange}
              required
              placeholder="message"
            />
            <label
              htmlFor="message"
              className="absolute left-0 top-2 ml-2 -translate-y-5 bg-white px-1 text-base text-gray-500 duration-100 ease-linear peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-5 peer-focus:px-1 md:top-3 md:-translate-y-7 md:text-lg md:peer-focus:-translate-y-7 lg:top-4 lg:ml-3 lg:-translate-y-8 lg:text-xl lg:peer-focus:-translate-y-8"
            >
              Message (optional)
            </label>
          </div>
          <p className="text-sm text-gray-500 md:text-base lg:text-lg">
            We will use the information you provide to respond to your enquiry.
            Occasionally, we may also use your details to share updates, news,
            or marketing information about our services. You can opt out at any
            time. For more details on how we handle your data, please see our{" "}
            <Link
              to={"/data-policy"}
              className="text-secondaryColor hover:text-secondaryHover"
            >
              Privacy Policy
            </Link>
            .
          </p>
          <label
            htmlFor="terms_check"
            className="self-start text-base text-gray-500 md:text-lg lg:text-xl"
          >
            <span className="font-bold">Consent Checkbox</span>{" "}
            <span className="italic">(required for marketing purposes)</span>
          </label>
          <div className="flex gap-2 self-start md:gap-3">
            <input
              type="checkbox"
              name="terms_check"
              className="size-4 rounded-3xl lg:size-6"
              checked={termsChecked}
              onChange={() => setTermsChecked(!termsChecked)}
            />
            <p className="text-sm italic text-gray-500 md:text-base lg:text-lg">
              I consent to receive communications from Access CV.
            </p>
          </div>
          <button
            disabled={!termsChecked}
            type="submit"
            className="rounded-3xl bg-primaryColor px-4 py-2 text-base font-bold text-secondaryColor shadow-md transition-all hover:bg-primaryHover hover:shadow-lg focus:bg-primaryHover focus:shadow-none active:bg-primaryHover active:shadow-none md:py-3 md:text-base lg:px-5 lg:py-3 lg:text-lg xl:px-8 xl:py-4 xl:text-xl"
          >
            Submit
          </button>
        </form>
      </section>
    </div>
  );
}
